import React from 'react';
import { Select, AutoComplete, Tooltip, Icon, Button } from 'antd';
import AssignReportsFormWrapper from './AttachReportsForm.style';

const Option = Select.Option;
const AutoCompOption = AutoComplete.Option;

const AttachReportsForm = ({templateList,setTemplateId,templateReportList,selectedTemplateReports,searchReportTitles,searchReportResults,scratchReports,setScratchReports,removeScratchReports,handleAssignReports,handleTemplateReports,isReportAssigning,setConversationUser}) => {

    const template_list = templateList.map(template => <Option value={template.id}>{template.name}</Option>);
    let template_report_list = templateReportList.map(report => <Option value={report.id}>{report.title}</Option>);
    const search_report_results = searchReportResults.map(report => <AutoCompOption value={report.title + ":" + report.id}>{report.title}</AutoCompOption>);
    const scratch_report_tags = scratchReports.length ? scratchReports.map((tag,i) => <p className="ant-tag">{tag.split(":")[0]}<Icon type="close" onClick={() => removeScratchReports(i)} /></p>) : '' ;
    
    return(
      <AssignReportsFormWrapper>
        
        <div className="flex section-header">
          <Tooltip message="Go Back" onClick={() => setConversationUser({ id: 0 })}>
            <Icon type="arrow-left" className="back-arrow-btn" />
          </Tooltip>
          <h2>Assign Reports Form</h2>
        </div>

        <div className="add-from-template">
          <h4>From Template</h4>
          <div className="flex template-options">
            <Select style={{ width: '25%', margin: '10px 10px 0 0' }} placeholder="Select Template" onChange={setTemplateId}>
              {template_list}
            </Select>

            <Select allowClear mode="multiple" style={{ width: '75%', margin: '10px 0 0 10px' }} onChange={handleTemplateReports} placeholder="Edit Report List" value={selectedTemplateReports}>
              {template_report_list}
            </Select>
          </div>
          
        </div>

        <div className="add-from-scratch">
          <h4>From Scratch</h4>

          <AutoComplete
            allowClear
            mode="multiple"
            style={{ width: '100%' }}
            onSearch={(value) => searchReportTitles(value,'assign-reports')}
            onSelect={setScratchReports}
            placeholder="input here"
          >
            {search_report_results}
          </AutoComplete>
          <div className="flex scratch-report-tags">
            {scratch_report_tags}
          </div>

        </div>

        <Button type="primary" loading={isReportAssigning} onClick={handleAssignReports}>Assign</Button>

      </AssignReportsFormWrapper>
    )
}

export default AttachReportsForm;


// WEBPACK FOOTER //
// ./src/components/Box/AssignReportsForm/AttachReportsForm.js